export default __webpack_public_path__ + "static/media/Banner - Elevate Pro - Diamond Blue-1.9045c30e.jpg";